/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 17:48:59
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-23 17:53:28
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/modal.service.ts
 */
import { useState } from 'react';

function useModalService() {
  const [visible, setVisible] = useState(false);
  const [currentInstance, setCurrentInstance] = useState({});

  const onCancel = () => setVisible(false);

  const handleCheckDetail = (instance) => {
    setCurrentInstance(instance);
    setVisible(true);
  };

  return {
    instance: currentInstance,
    visible,
    onCancel,
    handleCheckDetail,
  };
}

export default useModalService;
